import { useState, useRef } from 'react';
import { useStore } from './store';
import { readDataFile, EMPTY_DATA } from './dataFile';

const GATE_PASSWORD = 'abms';

export default function Gate() {
  const { authed, setAuth, data, startSession } = useStore();

  if (!authed) return <PasswordPrompt onPass={() => setAuth(true)} />;
  if (!data) return <Bootstrap onReady={startSession} />;
  return null;
}

function PasswordPrompt({ onPass }) {
  const [val, setVal] = useState('');
  const [err, setErr] = useState(false);
  function submit(e) {
    e.preventDefault();
    if (val === GATE_PASSWORD) onPass();
    else { setErr(true); setVal(''); }
  }
  return (
    <div className="hero min-h-[80vh]">
      <form onSubmit={submit} className="card bg-base-200 shadow-lg w-96">
        <div className="card-body">
          <h2 className="card-title">Internal Tools</h2>
          <p className="text-sm opacity-70">Enter access password</p>
          <input
            type="password"
            autoFocus
            value={val}
            onChange={(e) => { setVal(e.target.value); setErr(false); }}
            className={`input input-bordered ${err ? 'input-error' : ''}`}
            placeholder="Password"
          />
          {err && <p className="text-error text-sm">Wrong password</p>}
          <div className="card-actions justify-end mt-2">
            <button type="submit" className="btn btn-primary">Enter</button>
          </div>
        </div>
      </form>
    </div>
  );
}

function Bootstrap({ onReady }) {
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  async function handleOpen(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    setErr('');
    setBusy(true);
    try {
      const decoded = await readDataFile(file);
      onReady({ ...EMPTY_DATA, ...decoded });
    } catch (ex) {
      setErr(ex.message || 'Failed to open file');
    } finally {
      setBusy(false);
      e.target.value = '';
    }
  }

  function handleFresh() {
    onReady({ ...EMPTY_DATA });
  }

  return (
    <div className="hero min-h-[80vh]">
      <div className="card bg-base-200 shadow-lg w-[28rem]">
        <div className="card-body">
          <h2 className="card-title">Load your data</h2>
          <p className="text-sm opacity-70">
            Your clients, counter, and drafts live in a JSON file you keep on your machine.
            Open an existing one or start fresh.
          </p>
          <input ref={fileRef} type="file" accept=".json,application/json"
                 onChange={handleOpen} disabled={busy}
                 className="file-input file-input-bordered mt-2" />
          {err && <p className="text-error text-sm">{err}</p>}
          <div className="divider">or</div>
          <button className="btn btn-primary" onClick={handleFresh} disabled={busy}>
            Start fresh
          </button>
        </div>
      </div>
    </div>
  );
}
